/**
 * O número das notas fiscais no menu — spec 0113 (FR-023).
 *
 * Conta o que pede ação na competência mais recente que exige nota: prontas para
 * emitir, rejeitadas e sem resposta do emissor. Sem competência que exija, o
 * servidor responde zero, e zero não mostra número.
 *
 * Terceira fonte do setor Corporativo, ao lado do Feedback e das planilhas: as
 * chaves se somam no registro. Lê a cada minuto, só com a aba do navegador
 * visível, e a casca a registra só para quem vê o Pagamento.
 */
import { registrarFonteDeContadores } from '../../../../config/contadores';
import { authFetch } from '../../../../services/api';

const INTERVALO_MS = 60_000;

let numero = 0;
let ligados = 0;
let relogio: number | undefined;
const avisos = new Set<() => void>();
let registrado = false;

async function ler(): Promise<void> {
  if (document.visibilityState !== 'visible') return;
  try {
    const res = await authFetch('/api/transportador/nfse/contador');
    if (!res.ok) return;
    const n = Number((await res.json())?.data?.pedemAcao) || 0;
    if (n !== numero) {
      numero = n;
      avisos.forEach((a) => a());
    }
  } catch {
    // Sem número é melhor que número errado: fica o da última leitura.
  }
}

export function registrarFonteDasNotas(): void {
  if (registrado) return;
  registrado = true;
  registrarFonteDeContadores('corporativo', {
    ler: () => ({ notasFiscais: numero }),
    assinar: (aviso) => { avisos.add(aviso); return () => { avisos.delete(aviso); }; },
    ligar: () => {
      ligados += 1;
      if (ligados === 1) {
        void ler();
        relogio = window.setInterval(() => { void ler(); }, INTERVALO_MS);
      }
      return () => {
        ligados -= 1;
        if (ligados === 0 && relogio !== undefined) { window.clearInterval(relogio); relogio = undefined; }
      };
    },
  }, 'notas-fiscais');
}
